const STATS_GAME_STATUS = {
  UPCOMING: 'Upcoming',
  LIVE: 'Live',
  COMPLETED: 'Completed',
  POSTPONED: 'Postponed',
  FORFEIT: 'Forfeit',
}

export default STATS_GAME_STATUS
